export default __webpack_public_path__ + "static/media/gallery-img-1.2bd4b39b.jpg";